import { ApprovalPage } from "./approval-page.ts";

if (!customElements.get("altto-approval-page")) {
  customElements.define("altto-approval-page", ApprovalPage);
}
